import { lumi } from '@/lib/lumi'
import { useState } from 'react'

interface SavedEstimate {
  _id: string
  userId: string
  zipCode: string
  squareFootage: number
  material: string
  estimateLow: number
  estimateHigh: number
  estimateName?: string
  projectDetails: any
  creator: string
  createdAt: string
  updatedAt: string
}

export function useSavedEstimates() {
  const [estimates, setEstimates] = useState<SavedEstimate[]>([])
  const [loading, setLoading] = useState(false)

  const fetchEstimates = async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.saved_estimates.list({
        sort: { createdAt: -1 }
      })
      setEstimates(list)
      console.log('Saved estimates fetched:', list)
    } catch (error) {
      console.error('Fetch saved estimates failed:', error)
    } finally {
      setLoading(false)
    }
  }

  const saveEstimate = async (estimateData: Omit<SavedEstimate, '_id' | 'creator' | 'createdAt' | 'updatedAt'>) => {
    try {
      const now = new Date().toISOString()
      const estimate = await lumi.entities.saved_estimates.create({
        ...estimateData,
        creator: estimateData.userId,
        createdAt: now,
        updatedAt: now
      })
      console.log('Estimate saved:', estimate)
      await fetchEstimates()
      return estimate
    } catch (error) {
      console.error('Save estimate failed:', error)
      throw error
    }
  }

  const deleteEstimate = async (estimateId: string) => {
    try {
      await lumi.entities.saved_estimates.delete(estimateId)
      console.log('Estimate deleted:', estimateId)
      await fetchEstimates()
    } catch (error) {
      console.error('Delete estimate failed:', error)
      throw error
    }
  }

  return { estimates, loading, fetchEstimates, saveEstimate, deleteEstimate }
}
